module.exports = __webpack_public_path__ + "img/salus_white.6c541a98.png";